<template>
  <section class="admin-content " id="contact-search">
    <Navbar/>
    <main class="admin-main">
       <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex flex-wrap align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-wifi-off" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">{{ students.length }} Enrollees Added Offline</h4>
              <small style="opacity: .8;">Enrollees saved on this device, waiting to sync</small>
            </div>
          </div>
        </div>
      </div>
       <section>
           <div class="container mt-n3 pb-5">

               <div class="row list">
                   <div class="col-lg-12 col-md-12">
                       <div class="card table-card shadow mb-4">
                         <AllEnrolleesOffline
                            :students="students"
                            @add-item="addStudent"
                            @remove-item="refreshStudent"
                            @update-item="refreshStudent"
                          />
                       </div>
                   </div>

               </div>


               <div class="vld-parent">
                    <loading :active.sync="isLoading"
                    loader="dots"
                    :can-cancel="true"
                    :is-full-page="fullPage"></loading>
                </div>


           </div>

       </section>
       </main>
   </section>
</template>

<script>
  import Navbar from '@/views/Navbar.vue'
  // Import component
     import Loading from 'vue-loading-overlay';
     // Import stylesheet
     import 'vue-loading-overlay/dist/vue-loading.css';
     // Init plugin
     import AllEnrolleesOffline from "./AllEnrolleesOffline.vue";
     import { initJsStore } from "./../../../service/idb_service";
     import { StudentService } from "./../../../service/student_service";
     import { Global } from "./../../../global";

export default {
  components: {
     Navbar, Loading, AllEnrolleesOffline
  },
  async beforeCreate() {
    try {
      const isDbCreated = await initJsStore();
      if (isDbCreated) {
        console.log("db created");
        // prefill database
      } else {
        console.log("db opened");
      }
    } catch (ex) {
      console.error(ex);
      alert(ex.message);
      Global.isIndexedDbSupported = false;
    }
  },
  mounted() {
    this.refreshStudent();
  },
  data(){
    return{
      isLoading: false,
      fullPage: true,
      states:"",
      clients:"",
      state:"",
      students: [],
      lga_states:"",
      register:{
                firstname:"",
                lastname:"",
                email:"",
                phone_number:"",
                type:"client",
                username:"",
                state:"",
                lga:"",
                ward:"",
                address:"",
            }
    }
  },
  beforeMount(){
    this.user = JSON.parse(localStorage.getItem('user'))

  },
  methods:{
    async refreshStudent() {
      this.isLoading = true
      this.students = await new StudentService().getStudents();
      let total = this.students.length;
      localStorage.setItem('synctotal', total)
      this.isLoading = false

    },
    addStudent(student) {
      this.students.push(student);
    }


  },
  created(){
    //
  }

}
</script>
